import React, {FC, useState} from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'
import {BreadCrumbs} from '../../../components/BreadCrumbs/breadCrumbrs'
import {Button} from '../../../components/Button/Button'
import {Input} from '../../../components/Input/Input'
import {Loading} from '../../../components/Loading/Loading'
import {POST} from '../../../services/api'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'

const ReviewHotelCategoryCreateForm: FC = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [saving, setSaving] = useState(false)

  // Campos do formulário
  const [title, setTitle] = useState('')
  const [order, setOrder] = useState('0')

  const handleSave = async () => {
    try {
      setSaving(true)
      setLoading(true)

      if (!title.trim()) {
        throw new Error('Informe o título da categoria.')
      }

      const payload = {
        title: title.trim(),
        order: Number(order) || 0,
      }

      const res = await POST('/review-hotel-category', payload)

      if (res?.success) {
        await Swal.fire({
          icon: 'success',
          title: 'Criada com sucesso',
          text: 'A categoria foi salva.',
        })
        navigate('/hospitality/feed-back/category')
      } else {
        throw new Error(res?.message || 'Não foi possível criar a categoria.')
      }
    } catch (error: any) {
      console.log(error)
      Swal.fire({
        icon: 'error',
        title: 'Erro ao criar',
        text: error?.message || 'Não foi possível criar a categoria.',
      })
    } finally {
      setSaving(false)
      setLoading(false)
    }
  }

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>Criar Categoria</span>
                <BreadCrumbs />
                <span className='text-muted mt-1 fw-bold fs-7'>
                  Cadastre uma nova categoria para agrupar os formulários.
                </span>
              </h3>
            </div>

            <div className='card-body'>
              <div className='row g-5 align-items-end'>
                <div className='col-md-6'>
                  <Input
                    label='Título'
                    inputAttr={{type: 'default'}}
                    value={title}
                    change={(value: string) => setTitle(value)}
                    placeholder='Ex: Quartos, Restaurante, Recepção...'
                    maxCaracteres={50}
                    required
                  />
                </div>

                <div className='col-md-6'>
                  <Input
                    label='Ordem'
                    inputAttr={{type: 'number'}}
                    value={order}
                    change={(value: string) => setOrder(value)}
                    placeholder='0'
                    marginTop='0'
                  />
                </div>
              </div>
            </div>

            <div className='card-footer d-flex justify-content-end gap-3 py-6'>
              <Button
                text='Voltar'
                color='info'
                size='small'
                click={() => navigate('/hospitality/feed-back/category')}
                btnClass='fw-bolder hover-scale'
              />
              <Button
                text='Salvar'
                color='primary'
                size='small'
                click={handleSave}
                loading={saving}
                btnClass='fw-bolder hover-scale'
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const ReviewHotelCategoryCreate: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {title: 'Categorias', path: '/hospitality/feed-back/category', isActive: true},
          {title: 'Criar', path: '#', isActive: true},
        ]}
      >
        Criar Categoria
      </PageTitle>
      <ReviewHotelCategoryCreateForm />
    </>
  )
}

export {ReviewHotelCategoryCreate}
